import {
  forwardRef,
  type InputHTMLAttributes,
  type LabelHTMLAttributes,
  type ReactNode,
  type SelectHTMLAttributes,
  type TextareaHTMLAttributes,
} from 'react';
import { cn } from '../../lib/utils.ts';

const field =
  'w-full rounded-md border border-slate-300 bg-white px-3 text-sm shadow-xs focus:border-brand focus:outline-none disabled:bg-slate-100';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => <input ref={ref} className={cn(field, 'h-9', className)} {...props} />,
);

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => <textarea ref={ref} className={cn(field, 'py-2', className)} {...props} />,
);

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => <select ref={ref} className={cn(field, 'h-9', className)} {...props} />,
);

export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  // biome-ignore lint/a11y/noLabelWithoutControl: 컨트롤은 children 으로 감싼다
  return <label className={cn('grid gap-1 text-sm font-medium text-slate-700', className)} {...props} />;
}

export function FieldError({ children }: { children?: ReactNode }) {
  return children ? <p className="text-xs text-bad">{children}</p> : null;
}
